import React from "react";
import { Grid, Typography } from "@mui/material";
import footerLogo from "../../Asset/bg/fillpictureLogo.png";
import { ButtonComponent } from "../../Component/Component";
import { APPLYNOW, HOMEFOOTERCONTENT } from "../../Constant/constant";
const Footer = (props) => {
  return (
    <Grid
      container
      className="home-footer-container"
    >
      <Grid
        item
        xl={12}
        sm={12}
        xs={12}
        md={12}
        lg={12}
        sx={{ width: "100%"}}
      >
        <img src={footerLogo} width={"75%"} alt=" " />
      </Grid>
      <Grid
        item
        xl={12}
        sm={12}
        xs={12}
        md={12}
        lg={12}
        className="home-footer-text-zindex"
      >
        <Typography
          className="home-footer-text"
        >
          {HOMEFOOTERCONTENT}
        </Typography>
        <ButtonComponent
        className="home-footer-btn"
        >
          {APPLYNOW}
        </ButtonComponent>
      </Grid>
    </Grid>
  );
};

export default Footer;
